var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgProfileModalCross = function SvgProfileModalCross(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "black",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3449 12.6982L25.345 12.6982C25.6092 12.434 26.0375 12.434 26.3017 12.6982C26.5659 12.9624 26.5659 13.3907 26.3018 13.6549C26.3018 13.6549 26.3017 13.6549 26.3017 13.6549L21.3097 18.6459L20.9561 18.9995L21.3097 19.3531L26.3017 24.3451C26.5659 24.6093 26.5659 25.0377 26.3017 25.3019C26.0375 25.5661 25.6092 25.5661 25.345 25.3019L20.3529 20.3098L19.9994 19.9562L19.6458 20.3099L14.6548 25.3019C14.6548 25.3019 14.6547 25.3019 14.6547 25.3019C14.4127 25.5439 14.0322 25.5643 13.7674 25.3625L13.6893 25.293C13.4339 25.0281 13.4368 24.6064 13.698 24.3451L13.6981 24.3451L18.6891 19.353L19.0426 18.9995L18.6891 18.646L13.698 13.6549C13.4338 13.3907 13.4338 12.9624 13.698 12.6982C13.9622 12.434 14.3906 12.434 14.6548 12.6982L19.6458 17.6892L19.9994 18.0427L20.3529 17.6893L25.3449 12.6982Z",
    fill: "white",
    stroke: "white"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgProfileModalCross);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/profile-modal-cross.261954ad63d0310fea4f021d04db0107.svg";